"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showDeprecationWarning = void 0;

var showDeprecationWarning = function showDeprecationWarning(_ref) {
  var deprecatedName = _ref.deprecatedName,
      replacementName = _ref.replacementName,
      docsLink = _ref.docsLink,
      version = _ref.version;
  var versionOfRemoval = !!version ? " and will be removed in Stencil ".concat(version) : " and will be removed in the next major release of Stencil";
  var replacementSuggestion = !!replacementName ? " Please use ".concat(replacementName, " instead.") : "";
  var docsReference = !!docsLink ? " See ".concat(docsLink, " for more information.") : "";
  var message = "Deprecated: ".concat(deprecatedName, " is deprecated").concat(versionOfRemoval, ".").concat(replacementSuggestion).concat(docsReference);

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
    console.warn(message);
  }
};

exports.showDeprecationWarning = showDeprecationWarning;